import React from 'react';
import { IconButton, Typography, useTheme } from '@mui/material';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import { makeStyles } from 'tss-react/mui';
import { generateUUID } from '../../utils/utils';

interface TablePaginationActionsProps {
  count: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => void;
}

const useStyles = makeStyles()(theme => {
  return {
    pageContainer: {
      flexShrink: 0,
      marginLeft: 20,
      marginRight: 12,
      marginBottom: 1,
      display: 'flex',
      alignItems: 'center',
    },
    pageItem: {
      width: 32,
      height: 32,
      borderRadius: 23,
      fontSize: 14,
      fontWeight: 'normal',
      color: theme.palette.success.contrastText,
      // margin: '0 10px',
    },
    activePage: {
      backgroundColor: '#dddee1 !important',
      pointerEvents: 'none' /* Полностью отключает взаимодействие с элементом */,
      cursor: 'default',
      '& .Mui-disabled': {
        color: theme.palette.success.contrastText,
      },
    },
    activePageButton: {
      padding: '6px',
      cursor: 'pointer',
      backgroundColor: '#dddee1 !important',
      '& .Mui-disabled': {
        color: theme.palette.success.contrastText,
      },
    },
  };
});

const TablePaginationActions: React.FC<TablePaginationActionsProps> = props => {
  const { count, page, rowsPerPage, onPageChange } = props;
  const theme = useTheme();
  const classes1 = useStyles();
  const { classes } = classes1;

  const countToArray = Array.from({ length: Math.ceil(count / rowsPerPage) }, (_, i) => i + 1);

  const handleFirstPageButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  const centerPagesFrom = page > 3 ? page - 1 : page;
  const centerPagesTo = countToArray[page] + (page < countToArray.length - 4 ? 1 : 0);

  const centerPages = countToArray.slice(centerPagesFrom, centerPagesTo);
  return (
    <div className={classes.pageContainer}>
      {/* <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label='first page'
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton> */}
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label='previous page'
        className={page !== 0 ? classes.activePageButton : ''}
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <div>
        {countToArray.length <= 6 ? (
          countToArray.map(n => {
            return (
              <IconButton
                key={generateUUID()}
                onClick={() => onPageChange(null, n - 1)}
                // disabled={n - 1 === page}
                aria-label={`page ${n}`}
                className={`${classes.pageItem} ${n - 1 === page && classes.activePage}`}
              >
                {n}
              </IconButton>
            );
          })
        ) : (
          <>
            {countToArray.slice(0, page === 2 ? 4 : 3).map(n => {
              return (
                <IconButton
                  key={generateUUID()}
                  onClick={() => onPageChange(null, n - 1)}
                  // disabled={n - 1 === page}
                  aria-label={`page ${n}`}
                  className={`${classes.pageItem} ${n - 1 === page && classes.activePage}`}
                >
                  {n}
                </IconButton>
              );
            })}
            {page > 4 ? <span style={{ fontSize: 20, margin: '0 10px' }}>. . .</span> : null}

            {page > 2 &&
              page < countToArray.length - 3 &&
              centerPages.map(n => {
                return (
                  <IconButton
                    key={generateUUID()}
                    onClick={() => onPageChange(null, n - 1)}
                    // disabled={n - 1 === page}
                    aria-label={`page ${n}`}
                    className={`${classes.pageItem} ${n - 1 === page && classes.activePage}`}
                    style={{ padding: n > 999 ? '0 25px' : '0' }}
                  >
                    {n}
                  </IconButton>
                );
              })}
            {page < countToArray.length - 5 && (
              <span style={{ fontSize: 20, margin: '0 10px' }}>. . .</span>
            )}

            {countToArray
              .slice(
                countToArray.length - (page === countToArray.length - 3 ? 4 : 3),
                countToArray.length
              )
              .map(n => {
                return (
                  <IconButton
                    key={n}
                    onClick={() => onPageChange(null, n - 1)}
                    // disabled={n - 1 === page}
                    aria-label={`page ${n}`}
                    className={`${classes.pageItem} ${n - 1 === page && classes.activePage}`}
                    style={{ padding: n > 999 ? '0 25px' : '0' }}
                  >
                    {n}
                  </IconButton>
                );
              })}
          </>
        )}
      </div>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label='next page'
        className={page !== countToArray.length - 1 ? classes.activePageButton : ''}
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      {/* <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label='last page'
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton> */}
    </div>
  );
};

export default TablePaginationActions;
